!(function () {
  "use strict";

  class VideoControls extends HTMLElement {
    constructor() {
      super();

      this._selectors = {
        playButton: '[js-video-play]',
        pauseButton: '[js-video-pause]',
        video: 'video'
      };
    }

    connectedCallback() {
      this.playButton = this.querySelector(this._selectors.playButton);
      this.pauseButton = this.querySelector(this._selectors.pauseButton);

      this.videos = null;

      const initVideos = () => {
        this.videos = this.querySelectorAll(this._selectors.video);
        this.pauseButton.classList.toggle('hidden');
      };
      
      const videos = this.querySelectorAll(this._selectors.video);
      
      if (videos.length > 0) {
        initVideos();
      } else {
        this.mutationObserver = new MutationObserver(() => {
          const videos = this.querySelectorAll(this._selectors.video);
          if (videos.length > 0) {
            this.mutationObserver.disconnect();
            initVideos();
          }
        });
      
        this.mutationObserver.observe(this, { childList: true, subtree: true });
      }

      this.playButton.addEventListener('click', this.playVideo.bind(this));
      this.pauseButton.addEventListener('click', this.pauseVideo.bind(this));
    }

    disconnectedCallback() {
      this.mutationObserver && this.mutationObserver.disconnect();
    }

    playVideo() {
      this.videos.forEach((video) => {
        video.userPaused = false;
        video.play();
      });
      this.playButton.classList.toggle('hidden');
      this.pauseButton.classList.toggle('hidden');
    }

    pauseVideo() {
      this.videos.forEach((video) => {
        video.userPaused = true;
        video.pause();
      });
      this.playButton.classList.toggle('hidden');
      this.pauseButton.classList.toggle('hidden');
    }
  }

  if (!customElements.get('s-video-controls')) {
    customElements.define('s-video-controls', VideoControls);
  }
})();